import { IBusStopLite, IBusStopLiteData } from "./busStopLite.types";

export class BusStopLite implements IBusStopLite {
  readonly id: string;
  readonly busStopName: string;
  readonly gateNoList?: string;

  constructor(data: IBusStopLiteData) {
    this.id = data.id;
    this.busStopName = data.busStopName;
    this.gateNoList = data.gateNoList;
  }
}
